import { render, staticRenderFns } from "./updatePassPhrase.vue?vue&type=template&id=4fbe2aa9&"
import script from "./updatePassPhrase.vue?vue&type=script&lang=js&"
export * from "./updatePassPhrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports